export const LOGOUT_REQUEST = 'core/LOGOUT_REQUEST';

export default () => {
    return {
        type: LOGOUT_REQUEST
    };
}
